module.exports = __webpack_public_path__ + "img/re-cpo-full.cae56ce1.png";